/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from 'react';
import Modal, { ModalHeader } from '../Modal';
import Button from '../Button';
import CanvasDraw from 'react-canvas-draw';

const EmployeeSignField = ({ open, setOpen, submit, uri }) => {
  const [brushRadius, setBrushRadius] = useState(3);

  const canvasDraw = useRef(null);

  const cancel = () => {
    setOpen(false);
  };


  const handleClear = () => {
    canvasDraw.current.clear();
  };

  const handleUndo = () => {
    canvasDraw.current.undo();
  };

  const handleChangeBrush = (e) => {
    const { value } = e.target;
    setBrushRadius(parseInt(value, 10));
  };

  const handleApply = () => {
    const canvas = document.querySelector(".canvas-draw canvas:nth-child(2)");
    const signImage = canvas.toDataURL("image/png");
    submit(signImage);
    cancel();
  };

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="sign-write">
        <ModalHeader>서명 하기</ModalHeader>
        <div className="canvas-wrap">
          <div className="cavas-controller-container">
            <Button
              size="sm"
              label="전체취소"
              color="text"
              action={handleClear}
            />
            <Button
              size="sm"
              label="실행취소"
              color="text"
              action={handleUndo}
            />
            <div className="brush-wrap">
              <span className="title">펜 크기</span>
              <input className="brush-input" type="number" min={1} max={10} value={brushRadius} onChange={handleChangeBrush} />
            </div>
          </div>
          <CanvasDraw
            ref={canvasDraw}
            className="canvas-draw"
            style={{
              boxShadow:
                "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)"
            }}
            brushRadius={brushRadius}
          />
        </div>
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          <Button
            className="button"
            size="lg"
            label="서명"
            action={handleApply}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EmployeeSignField;